import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'double-arrow-right-icon',
  templateUrl: './double-arrow-right-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DoubleArrowRightIconComponent {}
